export const KUDOS_AND_BADGES_LIST = `
	query kudosAndBadgesList($event_id: Uint) {
		kudosAndBadgesList(event_id: $event_id) {
			id
			name
			src
			active
			type
			limit
			point_receiver_value
			point_giver_value
			kudo_givens {
				id
				kudo_id
				attendee_receiver_id
			}
			groups {
				id
				name
			}
		}
	}
`;

export const ATTENDEE_BADGES_LIST = `
	query attendeeKudosList($event_id: Uint!, $attendee_id: Uint!) {
		attendeeKudosList(event_id: $event_id, attendee_id: $attendee_id) {
			badges {
				id
				src
				type
				name
			}
		}
	}
`;
